import React from 'react'
import './experience.css'


const Experiencebars = (props) => {  
  return (
    <div className="experienceBar" >
        <img src={props.img} alt={props.alt} className="experienceBarImg" />
        <div className="experienceBarText">
            <h2>{props.name}</h2><span><b>{props.time}</b></span>
            <p>{props.content}</p>
        </div>
    </div>
  )
}

export default Experiencebars
